module.exports = __webpack_public_path__ + "static/media/bag-white.0323723d.svg";